import { Title } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

import UserGroupsList from './UserGroupsList';

const UserGroups = () => {
  const { t } = useTranslation('editOrganization');
  return (
    <>
      <Title margin={{ vertical: 'xlg' }}>{t('UserGroups.title')}</Title>
      {/* Commented out because of yet missing functionality */}
      {/* <Button>{t('UserGroups.createGroupButton')}</Button> */}
      <UserGroupsList />
    </>
  );
};

export default UserGroups;
